<template>
    <div class="plist-recommend-box">
        <div class="container">
            <!-- 标题 -->
            <div class="plist-recommend-title">{{$t("message.plist.recommend")}}</div>
            <!-- 轮播图 -->
            <carousel
                :minSwipeDistance="40"
                :scrollPerPage="true"
                :speed="2000"
                :perPageCustom="[[500,5]]"
                paginationColor="#fff"
                paginationActiveColor="#ff6700"
                :paginationPadding="10"
                :paginationSize="12"
                :loop="true">
                <slide v-for="(item,index) in recommend_goods" :key="index">
                    <div class="plist-recommend-list">
                        <!-- 图片 -->
                        <div class="plist-recommend-list-img">
                            <img-loading
                                :src="item.goods_images[0]"
                                :href="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}">
                            </img-loading>
                        </div>
                        <!-- 标题 -->
                        <router-link :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}" class="plist-recommend-list-title">
                            {{item.goods_name}}
                        </router-link>
                        <!-- 价格 -->
                        <div class="plist-recommend-list-price" v-if="show_price && powerPrice">
                            <span>{{currency}}</span>
                            <span>{{item.shop_price}}</span>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState({
            currency: state => state.currency,
            recommend_goods: state => state.banner.recommend_goods,
            show_price: state => state.show_price
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
    components: {
        imgLoading: () => import("@/components/imgLoading")
    }
}
</script>

<style scoped>
/* 标题 */
.plist-recommend-title{
    margin-bottom: 30px;
    font-size: 30px;
    font-weight: 400;
    color: #757575;
}

/* 轮播图 */
.plist-recommend-list{
    width: 216px;
    height: 300px;
    background-color: #fff;
    text-align: center;
    padding: 0 20px;
    margin-right: 14px;
}
/* 图片 */
.plist-recommend-list-img{
    width: 100%;
    height: 200px;
    padding: 10px 0;
}
/* 标题 */
.plist-recommend-list-title{
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-flex;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 10px;
    color: #333;
}
/* 价格 */
.plist-recommend-list-price{
    color: #ff6700;
}
.plist-recommend-list-price>span + span{
    margin-left: 5px;
    font-size: 16px;
}
</style>
